exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body{font-size:10px}.padding{padding:0}.margin{margin:0}.fontSize{font-size:10px}hr{margin-top:-12px}@page{size:portrait}@media print{#printbtn{display:none}}.btn{background-color:#438eb9;color:#fff;padding-top:4px;padding-bottom:4px;cursor:pointer}#img{padding:1px;border:1px solid #021a40}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-18dc14b2","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/onlineadmission/AdmissionPrint.vue
// module id = 336
// module chunks = 0